import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { StreamKeyword } from '../_models';
import { BaseResponse, ListResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class StreamKeywordService {
    constructor(private http: HttpClient) { }

    getKeyword(id: any): Observable<StreamKeyword> { //detail
      return this.http.get(`${environment.apiUrl}/stream/keyword/find/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return new StreamKeyword().deserialize(data.data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getAll(filter: any): Observable<ListResponse>  { //listing
      return this.http.post(`${environment.apiUrl}/stream/keyword/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          if(data.status == 1 && data.data.list == undefined){
            return null;
          }else{
            return new ListResponse().deserialize(data, StreamKeyword);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    addKeyword(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/stream/keyword/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    updateKeyword(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/stream/keyword/update/${data.id}`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteKeyword(id: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/stream/keyword/delete/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getSelection(): Observable<any>{
      return this.http.get(`${environment.apiUrl}/stream/keyword/selection`).pipe(
        map((data:any)=>{
          return data;
        }),
        catchError(error => throwError(error.message ||error))
      );
    }

}
